import { Component, computed, input } from '@angular/core';
import { CheckboxInputComponent } from '../checkbox-input/checkbox-input.component';
import { ExpandableComponent } from '../expandable/expandable.component';

@Component({
  selector: 'ez-expandable-checkbox',
  imports: [CheckboxInputComponent, ExpandableComponent],
  templateUrl: './expandable-checkbox.component.html',
  styleUrl: './expandable-checkbox.component.scss',
})
export class ExpandableCheckboxComponent {
  readonly label = input.required<string>();
  readonly controlName = input.required<string>();
  readonly altText = input.required<string>();
  readonly name = input<string>();
  readonly required = input<boolean>(false);

  readonly checkboxName = computed(() => {
    const name = this.name();
    return name ? name : this.controlName();
  });
}
